import script from "./SummaryItemGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryItemGroup.vue?vue&type=script&setup=true&lang=js"

import "./SummaryItemGroup.vue?vue&type=style&index=0&id=b0ef6d8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0ef6d8e"]])

export default __exports__